import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

// Models
import { ApiResponse } from '../shared/models/api-response.model';
import { ErrorTriggers } from './models/error-triggers.model';
import { PaymentTerm } from './models/payment-term.model';
import { PaymentPlanPreview } from './models/payment-plan-preview.model';
import { SaleGroupItem } from './models/sale-group-items.model';

@Injectable({
  providedIn: 'root'
})

export class PaymentTermsService {

  errorTriggers: ErrorTriggers = {};
  selectedPaymentTermSubject = new BehaviorSubject<any>({});
  $paymentTerm = this.selectedPaymentTermSubject.asObservable();
  customDatesSubject = new BehaviorSubject<any>({});
  $customDates = this.customDatesSubject.asObservable();
  upfrontPaymentAmountSubject = new BehaviorSubject<any>({});
  $upfrontPayment = this.upfrontPaymentAmountSubject.asObservable();
  triggerPaymentTermErrorSubject = new BehaviorSubject<any>({});
  $triggerError = this.triggerPaymentTermErrorSubject.asObservable();

  constructor(public httpClient: HttpClient) { }

  protected static getIndexUri(): string {
    return environment.apiUrl + 'payment_terms';
  }

  protected static getPreviewUri(): string {
    return environment.apiUrl + 'payment_plans/new';
  }

  private static getOptions(params?: object): object {
    return {
      params: params,
      withCredentials: true,
      headers: {
        Accept: 'application/json'
      }
    };
  }

  public getPaymentTerms(orgId: string): Observable<ApiResponse<PaymentTerm[]>> {
    const params = { organization_id: orgId, 'order[name]': 'asc' };
    return this.httpClient.get<ApiResponse<PaymentTerm[]>>(
      PaymentTermsService.getIndexUri(),
      PaymentTermsService.getOptions(params)
    );
  }

  public getPlanPreview(
    paymentTermId: number,
    saleGroupItems?: SaleGroupItem[],
    initialAmount?: number,
    totalAmount?: string
  ): Observable<ApiResponse<PaymentPlanPreview>> {
    const params = { payment_term_id: paymentTermId };
    if (saleGroupItems) {
      params['invoice_group_items'] = JSON.stringify(saleGroupItems);
    } else {
      params['initial_amount'] = initialAmount;
      params['total_amount'] = totalAmount;
    }
    return this.httpClient.get<ApiResponse<PaymentPlanPreview>>(
      PaymentTermsService.getPreviewUri(),
      PaymentTermsService.getOptions(params)
    );
  }

  public updateErrorTriggers(triggers: ErrorTriggers): void {
    Object.keys(triggers).forEach((triggerKey) => {
      this.errorTriggers[triggerKey] = triggers[triggerKey];
    });
    this.triggerPaymentTermErrorSubject.next(this.errorTriggers);
  }
}
